import React, { ComponentType, Suspense } from 'react';
/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import { hot } from 'react-hot-loader';
import LoadingBackdrop from 'design-v2/common/LoadingBackdrop';

const NS = 'FloorPlanV2Loader';

const ThemeWrap = function () {
  // window.__PIXI_APP__ only has value until this component is loaded
  const FloorPlanV2 = React.lazy(() => import('./FloorPlanV2ReactContainer'));

  return (
    <Suspense fallback={<LoadingBackdrop status="LOADING" />}>
      <FloorPlanV2 useKeepPixiApp={false} />
    </Suspense>
  );
};
/**
 * Returns properties needed for rendering react2angular
 */
export const R2AFloorPlanV2: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
];
